const styles = theme => ({
  marquee: {
    height: "82vh",
    width: "100%",
    overflow: "hidden",
    position: "relative"
  },
  marqueeAnimated: {
    position: "absolute", // remove from document flow
    top: 0,
    left: 0,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    transition: "transform 0.75s ease-in-out"
  },
  marqueeItem: {
    margin: 0,
    padding: 0,
    border: 0,
    flexShrink: 0,
    width: "100%"
  },

  loader: {
    color: "#fff"
  },
  placeDonationText: {
    color: theme.palette.common.white,
    fontWeight: 100,
    fontSize: "2.4rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  marqueeViewport: {
    position: "relative",
    overflow: "hidden",
    height: "100% !important", // dynamically adjusted in scrolling shoutouts
    width: "100%"
  },
  marqueeList: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/Template/Blocks/ScrollingShoutouts/styles.js